import React, { useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  Stack,
  Slide,
  Icon,
  TableContainer,
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Divider,
} from "investira.react.components";

import { displays } from "investira.react.lib";
import { formats } from "investira.sdk";
import { PessoaImage } from "../../../../../components/molecules";
import { ATIVO_TIPO } from "@investirapri/financa.js/lib/enums";

const commonColumns = {
  pessoa: { key: "pessoa", label: "", align: "left" },
  pessoa_fantasia: { key: "pessoa_fantasia", label: "Pessoa", align: "left" },
  ativo: { key: "ativo", label: "Ativo", align: "left" },
  ticker: { key: "ticker", label: "Ticker", align: "left" },
  cnpj: { key: "cnpj", label: "CNPJ", align: "left" },
  isin: { key: "isin", label: "ISIN", align: "left" },
  emissor: { key: "emissor", label: "Emissor", align: "left" },
  financeiro: { key: "financeiro", label: "Financeiro", align: "right" },
  vencimento: { key: "vencimento", label: "Vencimento", align: "left" },
  codigo: { key: "codigo", label: "Código", align: "left" },
  ativo_tipo: { key: "ativo_tipo", label: "Tipo de Ativo", align: "left" },
  serie: { key: "serie", label: "Série", align: "left" },
  curva: { key: "curva_id", label: "Curva", align: "left" },
  erro: { key: "erro", label: "Obs", align: "left" },
};

const columns = {
  pessoas: [
    commonColumns.pessoa,
    commonColumns.pessoa_fantasia,
    commonColumns.cnpj,
    commonColumns.financeiro,
    commonColumns.erro,
  ],
  ativos: [
    commonColumns.pessoa,
    commonColumns.ativo,
    commonColumns.isin,
    commonColumns.codigo,
    commonColumns.financeiro,
    commonColumns.erro,
  ],
};

const labels = {
  base: "Base",
  data: "Data",
  tipo: "Tipo",
  valor: "Valor",
  consolidacao_tipo: "Tipo de Consolidação",
  rota: "Rota",
  nivel: "Nível da Rota",
  arvore: "Árvore da Rota",
  fator: "Fator",
  aberta: "Aberta",
  contabil: "Contábil",
  caixa: "Caixa",
  provisoes: "Provisões",
  posicao_direta: "Posição Direta",
  financeiro: "Posição Direta Financeiro",
  quantidade: "Posição Direta Quantidade",
  fator_proporcional: "Fator Proporcional",
};

const ObservacoesDetalhe = (props) => {
  const { data } = props;
  const [selectedItem, setSelectedItem] = useState(null);
  const [showList, setShowList] = useState(true);
  const [showDetail, setShowDetail] = useState(false);

  const xLabels = { pessoas: "Pessoas", ativos: "Ativos" };

  const separarObservacoes = (pArray) => {
    if (!pArray || pArray.length === 0) {
      return { pessoas: [], ativos: [] };
    }

    const pessoas = [];
    const ativos = [];

    pArray.forEach((xObj) => {
      if (xObj.pessoa && !xObj.ativo) {
        pessoas.push(xObj);
      } else if (!xObj.pessoa && xObj.ativo) {
        ativos.push(xObj);
      }
    });

    return { pessoas, ativos };
  };

  const handleBackClick = () => {
    setShowDetail(false);

    // Pequeno delay para a animação ser mais fluida
    setTimeout(() => {
      setShowList(true);
      setSelectedItem(null);
    }, 100);
  };

  const xObservacoes = separarObservacoes(data.response?.resumo.erros);

  return (
    <Box
      sx={{
        width: "100%",
        mx: "auto",
        position: "relative",
        overflow: "hidden",
        pb: 2,
        transition: "all 0.1s ease-in-out",
      }}
    >
      <Slide direction="right" in={showList} mountOnEnter unmountOnExit>
        <Stack sx={{ height: "100%" }}>
          {data.response?.resumo.erros &&
            Object.entries(xObservacoes).map(([xKey, xValue]) => {
              return (
                <Stack key={xKey}>
                  <Stack>
                    <Typography variant="subtitle1">
                      <b>{xLabels[xKey]}</b>
                    </Typography>
                  </Stack>
                  <TableContainer
                    id="table-container"
                    sx={{
                      overflow: "auto",
                      mb: 3,
                    }}
                  >
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          {columns[xKey].map((column) => (
                            <TableCell key={column.key} align={column.align}>
                              {column.label}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {xValue.map((xItem, xIndex) => {
                          return (
                            <TableRow key={crypto.randomUUID()}>
                              {columns[xKey].map((column) => {
                                if (column.key === "pessoa") {
                                  return (
                                    <TableCell
                                      key={column.key}
                                      sx={{ width: "24px" }}
                                    >
                                      <PessoaImage
                                        logoPessoaId={xItem.logo_pessoa_id}
                                        alt={xItem.pessoa_fantasia}
                                        hasLogo={Boolean(xItem?.logo_pessoa_id)}
                                        size={24}
                                      />
                                    </TableCell>
                                  );
                                }

                                const value = xItem[column.key];

                                if (column.key === "ativo") {
                                  return (
                                    <TableCell key={column.key}>
                                      {value}
                                    </TableCell>
                                  );
                                }

                                if (column.key === "cnpj") {
                                  return (
                                    <TableCell
                                      key={column.key}
                                      sx={{
                                        width: "24px",
                                        whiteSpace: "nowrap",
                                      }}
                                      align="right"
                                    >
                                      {displays.cnpj(value)}
                                    </TableCell>
                                  );
                                }

                                const isDate = [
                                  "operacao_data",
                                  "emissao",
                                  "vencimento",
                                ].includes(column.key);

                                const isNumber = [
                                  "quantidade",
                                  "pu",
                                  "financeiro",
                                  "taxa",
                                ].includes(column.key);

                                return (
                                  <TableCell
                                    key={column.key}
                                    align={column.align}
                                  >
                                    {isNumber && value
                                      ? formats.formatNumber(value, 2, true)
                                      : isDate && value
                                      ? formats.formatDateCustom(
                                          value,
                                          "DD/MM/YYYY"
                                        )
                                      : value}

                                    {}
                                  </TableCell>
                                );
                              })}
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Stack>
              );
            })}
        </Stack>
      </Slide>

      <Slide direction="left" in={showDetail} mountOnEnter unmountOnExit>
        <Stack
          sx={{
            height: "100%",
            width: "100%",
          }}
        >
          {selectedItem && (
            <>
              <Box
                sx={{ display: "flex", alignItems: "center", mb: 1, px: 1.5 }}
              >
                <IconButton
                  onClick={handleBackClick}
                  edge="start"
                  sx={{ mr: 1 }}
                  color="primary"
                >
                  <Icon iconName="arrow-previous" size={18} />
                </IconButton>
              </Box>
              <Divider />
              <Box sx={{ overflow: "auto", maxHeight: 600 }}>
                <Stack py={2}>
                  <Stack mb={1}>
                    <PessoaImage
                      logoPessoaId={selectedItem.logo_pessoa_id}
                      alt={selectedItem.gestor.pessoa_fantasia}
                      hasLogo={Boolean(selectedItem?.logo_pessoa_id)}
                      size={50}
                    />
                  </Stack>
                  <Typography variant="subtitle1">
                    <b>{selectedItem.pessoa_fantasia}</b>
                  </Typography>
                </Stack>
                <Divider />

                <Stack py={1}>
                  <Typography variant="caption" color={"textSecondary"}>
                    {ATIVO_TIPO[selectedItem.ativo_tipo_id].descricao}
                  </Typography>
                </Stack>
                <Divider />
                <Stack py={1}>
                  {selectedItem.participacao && (
                    <>
                      {Object.entries(selectedItem.participacao)
                        .sort()
                        .map(([key, value]) => (
                          <React.Fragment key={key}>
                            <Typography
                              variant="body2"
                              color="text.primary"
                              sx={{ mb: 1 }}
                            >
                              <b>
                                {key === "aberta" ? "Posição" : labels[key]}
                              </b>
                            </Typography>
                            <Stack mb={2}>
                              <TableContainer>
                                <Table size="small">
                                  <TableBody>
                                    {typeof value === "object" ? (
                                      Object.entries(value).map(
                                        ([subKey, subValue]) => (
                                          <TableRow key={subKey}>
                                            <TableCell>
                                              {labels[subKey]}
                                            </TableCell>
                                            <TableCell align="right">
                                              {subKey === "arvore"
                                                ? subValue
                                                    .split(",")
                                                    .join(" > ")
                                                : subKey === "data"
                                                ? formats.formatDate(
                                                    subValue,
                                                    "DD/MM/YYYY"
                                                  )
                                                : typeof subValue === "boolean"
                                                ? subValue
                                                  ? "Sim"
                                                  : "Não"
                                                : [
                                                    "consolidacao_tipo",
                                                    "nivel",
                                                    "fator",
                                                    "fator_proporcional",
                                                  ].includes(subKey)
                                                ? subValue
                                                : subValue.toLocaleString(
                                                    "pt-BR",
                                                    {
                                                      minimumFractionDigits: 2,
                                                      maximumFractionDigits: 2,
                                                    }
                                                  )}
                                            </TableCell>
                                          </TableRow>
                                        )
                                      )
                                    ) : (
                                      <TableRow>
                                        <TableCell>{labels[key]}</TableCell>
                                        <TableCell align="right">
                                          {key === "arvore"
                                            ? value.split(",").join(" > ")
                                            : key === "data"
                                            ? formats.formatDate(
                                                value,
                                                "DD/MM/YYYY"
                                              )
                                            : typeof value === "boolean"
                                            ? value
                                              ? "Sim"
                                              : "Não"
                                            : [
                                                "consolidacao_tipo",
                                                "nivel",
                                                "fator",
                                                "fator_proporcional",
                                              ].includes(key)
                                            ? value
                                            : value.toLocaleString("pt-BR", {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                        </TableCell>
                                      </TableRow>
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </Stack>
                          </React.Fragment>
                        ))}
                    </>
                  )}

                  <Typography variant="caption" color="text.secondary">
                    Gestor: {selectedItem.gestor.pessoa_fantasia} (
                    {displays.cnpj(selectedItem.gestor.cnpj)})
                  </Typography>
                </Stack>
              </Box>
            </>
          )}
        </Stack>
      </Slide>
    </Box>
  );
};

export default ObservacoesDetalhe;
